import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Card } from '@/components/ui/card';
import { GitFork } from 'lucide-react';

export function ConditionNode({ data, selected }: any) {
  return (
    <div className="relative">
      <Handle type="target" position={Position.Left} className="!bg-primary !w-2 !h-2" />
      <Handle type="source" position={Position.Right} id="true" style={{ top: '30%' }} className="!bg-green-500 !w-2 !h-2" />
      <Handle type="source" position={Position.Right} id="false" style={{ top: '70%' }} className="!bg-red-500 !w-2 !h-2" />
      <Card
        className={`w-[240px] p-3 border-2 transition-shadow cursor-pointer ${
          selected ? 'border-primary shadow-lg ring-2 ring-primary/20' : 'border-zinc-300 dark:border-zinc-700'
        } bg-zinc-50 dark:bg-zinc-900/40`}
      >
        <div className="flex items-center gap-2 mb-2">
          <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-zinc-100 dark:bg-zinc-800">
            <GitFork className="w-4 h-4 text-zinc-900 dark:text-zinc-100" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs font-medium text-zinc-500 dark:text-zinc-400 uppercase tracking-wide">Condition</div>
            <div className="text-sm font-semibold truncate">{data.label || 'Check'}</div>
          </div>
        </div>
        {data.field && (
          <div className="text-xs text-muted-foreground truncate">
            {data.field} {data.operator} {data.value}
          </div>
        )}
        <div className="flex justify-between mt-2 text-xs">
          <span className="text-green-600 dark:text-green-400 font-medium">True →</span>
          <span className="text-red-600 dark:text-red-400 font-medium">False →</span>
        </div>
      </Card>
    </div>
  );
}
